module.exports = __webpack_public_path__ + "img/star.2417a3ca.svg";